import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import {
  BrandThemesEnum, IComponentWrapper, ILink, SdComponentWrapperComponent, SizesEnum, ThemesEnum
} from '@seb/web-design-system/core';

import { ISubcategory, SdSubcategoriesComponent } from '@seb/web-design-system/subcategories';
import { WC_CONFIG_PROVIDER, WcConfig } from '@seb/web-common/core/models';
import { HeadingParagraphMapper } from '@seb/web-common/core/mappers';
import { TrackingService } from '@seb/web-common/core/services';

@Component({
  selector: 'wc-accessory-categories',
  templateUrl: './accessory-categories.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdComponentWrapperComponent,
    SdSubcategoriesComponent
  ]
})
export class AccessoryCategoriesComponent {
  @Input()
  dataCategories: ISubcategory[];

  categoriesWrapper: IComponentWrapper;
  backgroundTheme: ThemesEnum | BrandThemesEnum;

  constructor(
    private trackingService: TrackingService,
    translateService: TranslateService,
    headingParagraphMapper: HeadingParagraphMapper,
    @Inject(WC_CONFIG_PROVIDER) wcConfig: WcConfig
  ) {
    this.backgroundTheme = wcConfig?.accessoryPage?.categories?.backgroundTheme;

    const richParagraphData = {
      heading: {
        headline: translateService.instant('accessory.title')
      },
      titleTheme: wcConfig?.accessoryPage?.categories?.titleTheme,
      titleLevel: 2,
      size: SizesEnum.l
    };

    this.categoriesWrapper = {
      heading: headingParagraphMapper.toHeadingParagraph(richParagraphData),
      footNotes: [],
      links: []
    };
  }

  onClickSubCat(link: ILink): void {
    this.trackingService.sendEvent('clickAccessoryCategory', {
      categoryName: link.linkName
    });
  }
}
